import { Account, AccountType, LifecycleStatus } from '@ndvr/portfolio-api';

// Investment style configuration.
// Factor tilts (momentum, value, low volatility, quality) are not investment styles: they come from the
// direct indexing strategy (DirectIndex) of the allocation.
// Tax loss harvesting is an account-level property: the portfolio-level switch fans it out to every
// account of the group that supports it. The group-level aggregate ("on for the whole portfolio") is
// computed by the backend and read from PortfolioTradePreferences.taxLossHarvesting.
export const TAX_LOSS_HARVESTING = {
    key: 'taxLossHarvesting',
    label: 'Tax Loss Harvesting',
    shortLabel: 'TLH',
} as const;

/** Mirrors Account.isTaxLossHarvestingCapable: only open taxable accounts can harvest losses (drives switch enablement). */
export const supportsTaxLossHarvesting = (account: Pick<Account, 'accountType' | 'lifecycleStatus'>) =>
    account.accountType === AccountType.TAXABLE && account.lifecycleStatus !== LifecycleStatus.CLOSED;
